import React from 'react';
import EmitTokenButton from './EmitTokenButton';
import RevokeTokenButton from './RevokeTokenButton';
import DeleteMerchantButton from './DeleteMerchantButton';
import ReissueTokenButton from './ReissueTokenButton';
import styles from './styles.module.scss';

type Props = {
  merchant: any;
  reloadMerchants: () => Promise<any>;
  hasAlternativeAccount: boolean;
};

const ActionCell: React.FC<Props> = ({ merchant, reloadMerchants, hasAlternativeAccount }) =>
  !merchant.active ? (
    <div className={styles['button-wrapper']}>
      <DeleteMerchantButton merchant={merchant} reloadMerchants={reloadMerchants} />
    </div>
  ) : merchant.tokenEmissionTimestamp ? (
    <>
      <div className={styles['button-wrapper']}>
        <RevokeTokenButton merchant={merchant} reloadMerchants={reloadMerchants} />
      </div>
      <div className={styles['button-wrapper']}>
        <ReissueTokenButton merchant={merchant} reloadMerchants={reloadMerchants} />
      </div>
    </>
  ) : (
    <>
      <div className={styles['button-wrapper']}>
        <EmitTokenButton merchant={merchant} reloadMerchants={reloadMerchants} />
      </div>
      {hasAlternativeAccount && (
        <div className={styles['button-wrapper']}>
          <EmitTokenButton alternativeAccount={true} merchant={merchant} reloadMerchants={reloadMerchants} />
        </div>
      )}
    </>
    
  );

export default ActionCell;
